import React from 'react'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import Skeleton from '@material-ui/lab/Skeleton'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '45px',
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
      marginBottom: '70px',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: '12px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(3),
  },
  metadata: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
  },
}))

const EventsLoadingSkeleton = () => {
  const classes = useStyles()

  return (
    <Box
      className={classes.root}
      data-testid="group-events-loading-skeleton"
      role="status"
      aria-label="Loading group events"
    >
      <Grid container spacing={4}>
        {new Array(3).fill().map((_, index) => (
          <Grid key={index} item lg={4} md={6} sm={12}>
            <Card variant="outlined" className={classes.card}>
              <Skeleton
                aria-hidden="true"
                variant="rect"
                height={140}
                animation="wave"
              />
              <Box className={classes.content}>
                <Skeleton
                  aria-hidden="true"
                  variant="text"
                  width="75%"
                  height={28}
                  animation="wave"
                />
                <Box className={classes.metadata}>
                  {new Array(4).fill().map((__, metadataIndex) => (
                    <Skeleton
                      key={metadataIndex}
                      aria-hidden="true"
                      variant="text"
                      width={metadataIndex === 1 ? '90%' : '65%'}
                      height={18}
                      animation="wave"
                    />
                  ))}
                </Box>
                <Box className={classes.footer}>
                  <Skeleton
                    aria-hidden="true"
                    variant="text"
                    width={70}
                    height={28}
                    animation="wave"
                  />
                  <Skeleton
                    aria-hidden="true"
                    variant="circle"
                    width={24}
                    height={24}
                    animation="wave"
                  />
                </Box>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default EventsLoadingSkeleton
